import { Inject } from '@odinjs/odin';

import { Endpoint, FOUNDATION_ROUTES } from '@philips-emr/hpms-provider-accreditation-commons';
import { ButtonAPI, FieldAPI, FormAPI, PanelAPI, ToastNotificationAPI } from '@philips-emr/tws-components';
import { ToastLevel } from '@philips-emr/tws-constants';
import Controller, { OnAfterFetch, OnClick, OnClose, OnValidate } from '@philips-emr/tws-core/lib/client';
import { ValidateEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService } from '@philips-emr/tws-core/lib/services';
import { applicationContext } from '@philips-emr/tws-foundation';

import { ResetPwAliases as Aliases, FragmentNames } from '../../codegen';

@Controller({ fragment: FragmentNames.RESET_PW })
export default class ResetPwController {

  @Inject(Aliases.FORM_RESET_PW)
  private formResetPw: FormAPI;

  @Inject(Aliases.BUTTON_CONFIRM)
  private buttonConfirm: ButtonAPI;

  @Inject(Aliases.PANEL_LOADER)
  private panelLoader: PanelAPI;

  @Inject(Aliases.PANEL_ACTIONS)
  private panelActions: PanelAPI;

  @Inject(Aliases.PANEL_SCREEN)
  private panelScreen: PanelAPI;

  @Inject(Aliases.FIELD_RECAPTCHA)
  private fieldRecaptcha: FieldAPI;

  @Inject(Aliases.TOAST_NOTIFICATION)
  private toastNotificationApi: ToastNotificationAPI;

  @Inject(Aliases.PANEL_SUCCESS_RESET_PW)
  private panelSuccess: PanelAPI;

  @OnValidate(Aliases.FORM_RESET_PW)
  onValidateForm(event: ValidateEvent): void {
    this.buttonConfirm.setEnabled(event.valid);
  }

  @OnClick(Aliases.BUTTON_CONFIRM)
  onClickConfirm(): void {
    if (this.formResetPw.validate()) {
      this.panelLoader.setVisible(true);
      const body = this.formResetPw.getRecord();
      HttpService.post(Endpoint.POST.RESET_PASSWORD, {}, { body })
        .then(() => {
          this.panelVisible();
        }).catch(resp => {
          this.resetValidations();
          const { response, status } = resp.body;
          this.showToastForm(status, response);
        });
    }
  }

  private panelVisible(): void {
    this.panelScreen.setVisible(false);
    this.panelSuccess.setVisible(true);
  }

  private resetValidations(): void {
    this.panelLoader.setVisible(false);
    this.panelActions.setVisible(true);

    const w = window as unknown as { grecaptcha: { reset: Function } };
    this.fieldRecaptcha.setValue('');
    w.grecaptcha.reset();

    this.formResetPw.setEditing(true);
  }

  private showToastForm(level: string, msg: string): void {
    this.toastNotificationApi.setMessage(msg);
    this.toastNotificationApi.setVisible(true);
    if (level === 'warning') {
      this.toastNotificationApi.setLevel(ToastLevel.WARNING);
    } else {
      this.toastNotificationApi.setLevel(ToastLevel.ERROR);
    }
  }

  @OnClose(Aliases.TOAST_NOTIFICATION)
  onCloseToast(): void {
    this.toastNotificationApi.setVisible(false);
  }

  @OnAfterFetch(Aliases.FETCH_RECAPTCHA)
  onAfterFetchRecaptcha(): void {
    this.formResetPw.setLoading(false);
  }

  @OnClose(Aliases.MODAL_RESET_PW)
  onCloseModal(): void {
    applicationContext.redirect(FOUNDATION_ROUTES.LOGIN);
  }

  @OnClick(Aliases.BUTTON_OK)
  onClickOk(): void {
    applicationContext.redirect(FOUNDATION_ROUTES.LOGIN);
  }

}
